const chat = require('../../../../../components/chat/chat')
const chatHandler = require('../../../../../components/chat/chat-handler')
const handler = require('./sale-fullcont-handler')
const {
	buildChatCardWarning,
	readFullcontField,
	countMultitableLines,
	friendlySectionName,
} = require('../../../../../components/chat/chat-card-warning')

export function start(detail) {
	if (obj[detail.act]) {
		obj[detail.act].start(detail)
	}
}

const obj = {
	load: { start: (detail) => { load(detail) } },
	submit: { start: (detail) => { submit(detail) } },
	typing: { start: (detail) => { typing(detail) } },
	beforeChat: { start: (detail) => { beforeChat(detail) } },
	loadAllSales: { start: (detail) => { loadAllSales(detail) } },
}

const SALE_QUESTIONS = [
	'What is the status of the sale?',
	'What is the total amount of the sale?',
	'Were there any changes in the sale orders?',
	'Can I get a summary of this sale?',
]

const SALE_BEFORE_QUESTIONS = [
	'Is credit available?',
	'Price for this client?',
	'Is there stock available for sale?',
	'Is a discount applicable?',
]

const SALE_ALL_QUESTIONS = ['Total sales amount?', 'Sales summary?']

function getGeneralQuestions(type) {
	if (type === 'sale') {
		return SALE_QUESTIONS
	}

	if (type === 'saleBefore') {
		return SALE_BEFORE_QUESTIONS
	}

	if (type === 'saleAll') {
		return SALE_ALL_QUESTIONS
	}
}

function loadAllSales(detail) {
	const cardWarning = buildChatCardWarning({
		entityDisplay: 'Sales',
		typeLabel: 'Summary of multiple sales',
		recordId: '—',
		details: [
			{ label: 'What includes', value: 'Information from many sales together (representative sample)' },
			{ label: 'Sales', value: 'Various operations; the assistant works with sales-related information' },
			{ label: 'Your session', value: 'Only you see this conversation in your account' },
		],
		scopeNote:
			'The assistant works with a general overview of sales. The history may behave differently than in a specific sale.',
	})

	chat.start({
		dest: 'chat',
		act: 'quickview',
		actQuickview: 'show',
		type: 'saleAll',
		entity: 'sale',
		question: detail.question ?? '',
		generalQuestions: getGeneralQuestions('saleAll'),
		cardWarning: cardWarning,
		ev: detail.ev,
	})
}

function load(detail) {
	const fullcontActivo = document.getElementById(`${detail.dest}-fullcont`)
	const recordId = fullcontActivo.getAttribute('data-dbid')

	const lineCount = fullcontActivo
		? countMultitableLines(fullcontActivo, 'sale_form_sale_vs_item')
		: 0

	const details = fullcontActivo
		? [
				{ label: 'Sale code', value: readFullcontField(fullcontActivo, 'sale_form_code') },
				{ label: 'Customer', value: readFullcontField(fullcontActivo, 'sale_form_customer_id') },
				{ label: 'Sale date', value: readFullcontField(fullcontActivo, 'sale_form_sale_date') },
				{ label: 'Total', value: readFullcontField(fullcontActivo, 'sale_form_grand_total') },
				{
					label: 'Products in the detail',
					value: lineCount ? `${lineCount} línea(s)` : '—',
				},
		  ]
		: []

	const cardWarning = buildChatCardWarning({
		entityDisplay: friendlySectionName(detail.dest),
		typeLabel: 'Venta guardada',
		recordId: recordId || '—',
		details,
		scopeNote: 'La conversación corresponde solo a esta venta y al historial ya guardado aquí.',
	})

	if (recordId) {
		chat.start({
			dest: 'chat',
			act: 'quickview',
			actQuickview: 'show',
			type: 'sale',
			entity: 'sale',
			question: detail.question ?? '',
			recordId: recordId,
			ev: detail.ev,
			generalQuestions: getGeneralQuestions('sale'),
			cardWarning: cardWarning,
		})

		const msj = handler.getChatsFc()
		chat.start({
			dest: 'chat',
			act: 'load',
			chats: msj,
			generalQuestions: getGeneralQuestions('sale'),
			cardWarning: cardWarning,
		})
	}
}

function beforeChat(detail) {
	const htmlFc = handler.getDataFc()
	const dataToSend = handler.getValuesForChat(detail, htmlFc)
	if (!dataToSend) return

	const fc = document.getElementById(`${detail.dest}-fullcont`)
	const lineCount = fc ? countMultitableLines(fc, 'sale_form_sale_vs_item') : 0

	const details = fc
		? [
				{ label: 'Sale code', value: readFullcontField(fc, 'sale_form_code') },
				{ label: 'Customer', value: readFullcontField(fc, 'sale_form_customer_id') },
				{ label: 'Sale date', value: readFullcontField(fc, 'sale_form_sale_date') },
				{ label: 'Total', value: readFullcontField(fc, 'sale_form_grand_total') },
				{
					label: 'Products in the detail',
					value: lineCount ? `${lineCount} línea(s)` : '—',
				},
		  ]
		: [{ label: 'Status', value: 'Draft — the sale has not been saved yet' }]

	const cardWarning = buildChatCardWarning({
		entityDisplay: friendlySectionName(detail.dest),
		typeLabel: 'Before saving',
		recordId: fc ? fc.getAttribute('data-dbid') || '—' : '—',
		details,
		scopeNote:
			'The assistant uses what you see on screen. If you have not saved the sale, the chat history may be limited.',
	})

	chat.start({
		dest: 'chat',
		act: 'quickview',
		actQuickview: 'show',
		type: 'saleBefore',
		entity: 'sale',
		data: dataToSend,
		question: detail.question ?? '',
		ev: detail.ev,
		generalQuestions: getGeneralQuestions('saleBefore'),
		cardWarning: cardWarning,
	})
}

function submit(detail) {}

function typing(detail) {
	chatHandler.typing(detail)
}
